import React from 'react';
import { Palette } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Button } from '../ui/button';

const STICKY_COLORS = [
  { color: '#FFEB3B', name: 'Yellow' },
  { color: '#FFC107', name: 'Amber' },
  { color: '#FF9800', name: 'Orange' },
  { color: '#FF5722', name: 'Deep Orange' },
  { color: '#E91E63', name: 'Pink' },
  { color: '#9C27B0', name: 'Purple' },
  { color: '#673AB7', name: 'Deep Purple' },
  { color: '#3F51B5', name: 'Indigo' },
  { color: '#2196F3', name: 'Blue' },
  { color: '#03A9F4', name: 'Light Blue' },
  { color: '#00BCD4', name: 'Cyan' },
  { color: '#009688', name: 'Teal' },
  { color: '#4CAF50', name: 'Green' },
  { color: '#8BC34A', name: 'Light Green' },
  { color: '#CDDC39', name: 'Lime' },
  { color: '#FFFFFF', name: 'White' }
];

export default function StickyNotePropertiesPanel({ 
  element, 
  onUpdate,
  position 
}) {
  if (!element || element.type !== 'sticky_note') return null;
  
  const props = element.properties || {};
  const currentColor = props.color || '#FFEB3B';

  const handleColorChange = (color) => {
    onUpdate(element.id, {
      properties: { ...element.properties, color: color }
    });
  };

  return (
    <div 
      className="absolute z-50 flex items-center gap-1 bg-background rounded-lg border shadow-lg p-1"
      style={{ 
        left: position?.x || 100, 
        top: Math.max(10, (position?.y || 100) - 50)
      }}
    >
      {/* Color Picker */}
      <Popover>
        <PopoverTrigger asChild>
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-8 px-2 gap-2"
            data-testid="sticky-color-picker"
          >
            <div 
              className="w-4 h-4 rounded border border-gray-300"
              style={{ backgroundColor: currentColor }}
            />
            <Palette className="h-4 w-4" />
            <span className="text-xs">Color</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-3" side="bottom">
          <p className="text-xs font-medium mb-2">Sticky Note Color</p>
          <div className="grid grid-cols-4 gap-1">
            {STICKY_COLORS.map(({ color, name }) => (
              <button
                key={color}
                title={name}
                className={`w-7 h-7 rounded border-2 transition-all ${
                  currentColor === color 
                    ? 'border-primary scale-110' 
                    : 'border-transparent hover:border-gray-400'
                }`}
                style={{ backgroundColor: color }}
                onClick={() => handleColorChange(color)}
                data-testid={`sticky-color-${color.replace('#', '')}`}
              />
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
